import assert from 'assert';
import React, {useMemo} from 'react';

import {makeReactContext} from 'lib/makeReactContext';
import {Table} from 'notebook/tables/constants/TableConstants';
import {createHydratedTableSelector} from 'notebook/tables/store/selectors/TableSelectors';
import {Note} from 'notebook/util/NoteUtilConstants';

interface HydratedTableContextInterface {
  tableName: string;
  selectTable: (note: Note) => Table | null;
}

export const HydratedTableContext = makeReactContext<HydratedTableContextInterface>(() => {
  assert(false, 'HydratedTableContext must be used within a HydratedTableProvider');
}, 'NoteContext');

export function HydratedTableProvider({
  tableName,
  children,
}: {
  tableName: string;
  children: React.ReactNode;
}): JSX.Element {
  const selectTable = createHydratedTableSelector(tableName);
  const contextValue: HydratedTableContextInterface = useMemo(
    () => ({tableName, selectTable}),
    [tableName, selectTable]
  );
  return <HydratedTableContext.Provider value={contextValue}>{children}</HydratedTableContext.Provider>;
}
